import React, { useEffect } from "react";
import { Link } from "pepsico-ds";
import { useTranslation } from "react-i18next";

function Footer() {
  const { t, i18n } = useTranslation();
  const currentYear = `${new Date().getFullYear()}`;
  useEffect(() => {
    const footerContainer = document.getElementById("footer_container");
    if (window.location.pathname.includes("public")) {
      footerContainer.style.marginLeft = "0";
      footerContainer.style.zIndex = "1000";
    } else {
      footerContainer.style.marginLeft = "64";
      footerContainer.style.zIndex = "0";
    }    
  }, []);

  return (
    <div id="footer_container">
      <div className="col-12">
        <div className="col-1">
          <div className="pep_footer_logo_background"></div>
        </div>
        <div className="col-11 footer_links_section">
          <div className="footer_text_section">
            <span className="cardLabel" style={{ fontWeight: "400" }}>
              {t("footer_copyright").replace("YYYY",currentYear)}
            </span>
          </div>
          <div className="footerSeperator"></div>
          {/* </div>
                <div className='col-7 footer_links_section' > */}
          <div className="footer_link_align">
            <Link
              target="_blank"
              className="footer_links"
              href="https://secure.mypepsico.com/modernsso/Associate_SSO_Privacy.pdf"
              iconLeading=""
              iconTrailing=""
              label="Link"
              size="medium"
              style={{
                paddingLeft: "0.25rem",
                paddingRight: "0.25rem",
              }}
              useAnchor
            >
              {t("footer_privacy")}
            </Link>

            <Link
              target="_blank"
              className="footer_links"
              href="https://myidm.mypepsico.com/iam/im/pepsicopub/page/jsp/legalTermsConditions.jsp"
              iconLeading=""
              iconTrailing=""
              label="Link"
              size="medium"
              style={{
                paddingLeft: "0.25rem",
                paddingRight: "0.25rem",
              }}
              useAnchor
            >
              {t("footer_terms")}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
